import WriterApp from '@/src/writerApp'
import WriterDashboard from '@/pages/writers/dashboard/index'
import WriterProfile from '@/pages/writers/profiles/index'
import WriterEmail from '@/pages/writers/emails/index'
import WriterPasswords from '@/pages/admin/passwords'
import WriterPost from '@/pages/writers/posts/index'
import WriterPostEdit from '@/pages/writers/posts/edit'
import WriterOrderBoard from '@/pages/writers/orderBoards/index'
import WriterSystemInformations from '@/pages/writers/systemInformations/index'

import store from '@/store'

const inMasterAccess = (to, from, next) => {
  if (window.origin === process.env.MASTER_ORIGIN) {
    return store.commit('errorPage/setForbidden', true)
  }
  next()
}

export const writerDashboard = 'writerDashboard'
export const writerProfile = 'writerProfile'
export const writerEmail = 'writerEmail'
export const writerPasswords = 'writerPasswords'
export const writerPosts = 'writerPosts'
export const writerPostEdit = 'writerPostEdit'
export const writerOrderBoard = 'writerOrderBoard'
export const writerSystemInformations = 'writerSystemInformations'

export const pageNameMapper = [
  { searchValue: 'ほーむ', jaName: 'ホーム', name: writerDashboard },
  { searchValue: 'ぷろふぃーるへんしゅう', jaName: 'プロフィール編集', name: writerProfile },
  { searchValue: 'めーるあどれすへんこう', jaName: 'メールアドレス変更', name: writerEmail },
  { searchValue: 'ぱすわーどへんこう', jaName: 'パスワード変更', name: writerPasswords },
  { searchValue: 'しっぴつする', jaName: '執筆する', name: writerPosts },
  { searchValue: 'おうぼする', jaName: '応募する', name: writerOrderBoard },
  { searchValue: 'しすてむつうちいちらん', jaName: 'システム通知一覧', name: writerSystemInformations }
]

export default {
  path: '/writers',
  component: WriterApp,
  meta: { requiresAuth: true },
  beforeEnter: inMasterAccess,
  children: [
    {
      path: '',
      name: writerDashboard,
      component: WriterDashboard
    },
    {
      path: 'profiles',
      name: writerProfile,
      component: WriterProfile
    },
    {
      path: 'emails',
      name: writerEmail,
      component: WriterEmail
    },
    {
      path: 'passwords',
      name: writerPasswords,
      component: WriterPasswords
    },
    {
      path: 'posts',
      name: writerPosts,
      component: WriterPost
    },
    {
      path: 'posts/:id/edit',
      name: writerPostEdit,
      component: WriterPostEdit
    },
    {
      path: 'order_boards',
      name: writerOrderBoard,
      component: WriterOrderBoard
    },
    {
      path: 'system_informations',
      name: writerSystemInformations,
      component: WriterSystemInformations
    }
  ]
}
